"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanSelectionQueryToJSON = exports.PlanSelectionQueryFromJSONTyped = exports.PlanSelectionQueryFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function PlanSelectionQueryFromJSON(json) {
    return PlanSelectionQueryFromJSONTyped(json, false);
}
exports.PlanSelectionQueryFromJSON = PlanSelectionQueryFromJSON;
function PlanSelectionQueryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'key': json['key'],
        'description': !runtime_1.exists(json, 'description') ? undefined : json['description'],
        'services': (json['services'].map(_1.ServiceLineItemFromJSON)),
        'price': json['price'],
    };
}
exports.PlanSelectionQueryFromJSONTyped = PlanSelectionQueryFromJSONTyped;
function PlanSelectionQueryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'key': value.key,
        'description': value.description,
        'services': (value.services.map(_1.ServiceLineItemToJSON)),
        'price': value.price,
    };
}
exports.PlanSelectionQueryToJSON = PlanSelectionQueryToJSON;
//# sourceMappingURL=PlanSelectionQuery.js.map